import clsx from "clsx";
import { Script } from "gatsby";
import React, { FC, useCallback, useEffect, useState } from "react";

import { useLocaleContext } from "../../i18n/locale-context";
import { getCountryLanguageFromLocaleCode } from "../../utils/i18n";

export const CookiesDeclaration: FC = () => {
  const { locale } = useLocaleContext();
  const { language } = getCountryLanguageFromLocaleCode(locale);

  const [cookieDeclarationInnerHtml, setCookieDeclarationInnerHtml] = useState<string>();

  const onSetCookieDeclarationContent = useCallback(() => {
    if (document) {
      const cookieDeclarationElement =
        document.getElementsByClassName("CookieDeclaration")[0]?.parentElement ?? undefined;
      if (cookieDeclarationElement) {
        setCookieDeclarationInnerHtml(cookieDeclarationElement.innerHTML);
        cookieDeclarationElement.parentElement?.removeChild(cookieDeclarationElement);
        return;
      }
    }
    return requestAnimationFrame(() => {
      onSetCookieDeclarationContent();
    });
  }, []);

  useEffect(() => {
    const requestId = onSetCookieDeclarationContent();
    return () => {
      requestId && cancelAnimationFrame(requestId);
    };
  }, [onSetCookieDeclarationContent]);

  return process.env.GATSBY_COOKIEBOT_SCRIPT_SRC ? (
    <>
      <Script
        id="CookieDeclaration"
        src={process.env.GATSBY_COOKIEBOT_SCRIPT_SRC}
        type="text/javascript"
        data-culture={language}
      />
      {cookieDeclarationInnerHtml && (
        <div
          dangerouslySetInnerHTML={{ __html: cookieDeclarationInnerHtml }}
          className={clsx(
            "px-8 lg:px-20 bg-neutral-light py-20",
            "[&_.CookieDeclarationTypeHeader]:text-primary",
            "[&_.CookieDeclarationTableHeader]:text-primary",
            "[&_a]:text-primary [&_a]:underline",
            "[&_.CookieDeclarationType]:border-primary"
          )}
        />
      )}
    </>
  ) : (
    <></>
  );
};
